<template>
  <div class="channelCardDoc">
    <documentation-container :title="title">
      <template slot="content">
        <div class="content-doc">
          <channel-card v-for="(card, index) in cards" :key="index" :title='card.title' :color='card.color' :image='card.image' />
        </div>
      </template>
    </documentation-container>
  </div>
</template>

<script>
import ChannelCard from '@/components/Card/ChannelCard'
import DocumentationContainer from '@/components/DocumentationContainer'

export default {
  name: 'adx-channel-card-doc',
  components: {
    'channel-card': ChannelCard,
    'documentation-container': DocumentationContainer
  },
  data() {
    return {
      title: 'Channel Card',
      cards: [
        {
          title: 'Digital Screen',
          image: '/img/channel/digital.png',
          color: '#effff4'
        },
        {
          title: 'Billboard',
          image: '/img/channel/billboard.png',
          color: '#61a6d0'
        },
        {
          title: 'Digital Advertising',
          image: '/img/channel/sms.png',
          color: '#457a81'
        },
        {
          title: 'Experience Branding',
          image: '/img/channel/experience.png',
          color: '#a4787c'
        }
      ]
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>